import React, { memo } from 'react'
import { connect } from 'react-redux'
import { shallowEqual } from 'react-redux'
import Songs from './Songs'

const SongsContainer = memo(props => (
    <Songs
        id={props.id}
        name={props.name}
        variant={props.variant}

        isSelected={props.isSelected}
        isMarkItems={props.isMarkItems}
        cliptime={props.cliptime}
        tempo={props.tempo}
        genre_name={props.genre_name}
        year={props.year}
        filename={props.filename}
        audio={props.audio}
        isPlaying={props.isPlaying}
        play={props.play}
        pause={props.pause}
        rewind={props.rewind}
    />
), shallowEqual)

const stateToProps = (state, props) => {
    const isCurrentTrack = state.audio.currentTrack?.trackId === props.id
    return {
        isMarkItems: state.marks[state.marks.current].items.includes(props.id),
        isSelected: state.public_playlists.selected_song.includes(props.id),
        isPlaying: isCurrentTrack && state.audio.isPlaying,
        audio: state.audio.audio,
    }
}

export default connect(stateToProps, null)(SongsContainer)